export default {
  pageView: {
    prefillButtonShown: 'delivery_purchase_prefill_button_shown',
    invoiceChkbxShown: 'service_fee_chk_box_shown',
    deliverySellerInvoiceFormShown: 'delivery_seller_invoice_form_shown',
  },
  touchPointPages: {
    buyerInfo: 'delivery_purchase_buyer_info',
    buyerInfoConfirmationPage: 'delivery_purchase_confirmation_page',
  },
  events: {
    confirmation: {
      deliverySellerSelectPoint: 'delivery_seller_select_point',
      deliverySellerConfirmation: 'delivery_seller_confirmation',
      deliveryOrdersAcceptDeal: 'delivery_orders_accept_deal',
      deliverySellerConfirmSummary: 'delivery_seller_conf_summary',
      deliverySellerConfirmSummaryEdit: 'delivery_seller_conf_summary_edit',
      deliverySellerConfirmSubmit: 'delivery_seller_confirmation_submit',
      deliverySellerConfirmSummaryClick: 'delivery_seller_conf_summary_click',
      deliverySellerConfirmGoBack: 'delivery_seller_confirmation_goback',
      deliveryPurchaseConfirmationPage: 'delivery_purchase_confirmation_page',
      deliverySellerConfirmationDataRemembered: 'delivery_seller_confirmation_data_remembered',
      deliverySellerConfirmationDataAddressRemembered:
        'delivery_seller_confirmation_data_address_remembered',
      deliverySellerConfirmationDataNotRemembered:
        'delivery_seller_confirmation_data_not_remembered',
      deliverySellerConfirmationRememberDataCheck:
        'delivery_seller_confirmation_remember_data_check',
      deliverySellerConfirmationRememberDataUncheck:
        'delivery_seller_confirmation_remember_data_uncheck',
      deliverySellerConfirmationRememberDataCheckboxShown:
        'delivery_seller_confirmation_remember_data_checkbox_shown',
      deliverySellerConfirmationBankField: 'delivery_seller_confirmation_bank',
      deliverySellerConfirmationDobField: 'delivery_seller_confirmation_dob',
      prefillDataOptIn: 'delivery_seller_invoice_prefill_data_opt_in',
      prefillDataOptOut: 'delivery_seller_invoice_prefill_data_opt_out',
      deliverySellerConfirmationInvoiceOptIn: 'delivery_seller_confirmation_invoice_opt_in',
      deliverySellerConfirmationInvoiceOptOut: 'delivery_seller_confirmation_invoice_opt_out',
      deliverySellerConfirmationLabelOptionNotSelected: 'label_option_not_selected',
      deliverySellerConfirmationLabellessShippingClick: 'delivery_seller_conf_no_label',
      deliverySellerConfirmationLabelledShippingClick: 'delivery_seller_conf_print_label',
      deliverySellerConfirmationLabellessShippingShowMore: 'delivery_seller_conf_label_more_info',
      deliverySellerConfirmationLabellessShippingShowLess: 'delivery_seller_conf_label_less_info',
      deliveryKeepOlxDeliveryOn: 'delivery_seller_conf_delivery_on_opt_in',
      deliveryKeepOlxDeliveryOff: 'delivery_seller_conf_delivery_on_opt_out',
    },
    checkout: {
      prefillAgree: 'delivery_purchase_prefill_agree',
      prefillDecline: 'delivery_purchase_prefill_decline',
      returningBuyer: 'delivery_purchase_returning_buyer',
      prepopulationNoData: 'delivery_purchase_prep_nodata',
      prepopulationError: 'delivery_purchase_prep_error',
      buyWithDelivery: 'delivery_click',
      deliveryProviderFinal: 'delivery_purchase_provider_final',
      deliveryPurchaseBuyerInfoSubmit: 'delivery_purchase_buyer_info_submit',
      deliveryPurchasePointPrepopulated: 'delivery_purchase_point_prepopulated',
      deliveryPurchaseDataPrepopulated: 'delivery_purchase_data_prepopulated',
      confirmationConsentShown: 'delivery_confirmation_save_data_shown',
      confirmationConsentOptedIn: 'delivery_confirmation_save_data_opt_in',
      confirmationConsentOptedOut: 'delivery_confirmation_save_data_opt_out',
      confirmationConsentPrefilled: 'delivery_confirmation_prefilled_consent',
      deliveryConfirmationPageEdit: 'delivery_confirmation_page_edit',
      deliverySupportUkraineClick: 'delivery_support_ukraine_click',
      deliverySupportUkraineInfoClick: 'delivery_support_ukraine_info_click',
      deliverySupportUkraineRegulationsClick: 'delivery_support_ukraine_tc_click',
    },
    map: {
      deliverySellerMapView: 'delivery_seller_map_view',
      deliverySellerMapViewBack: 'delivery_seller_map_view_back',
      deliveryMapViewBack: 'delivery_map_view_back',
      deliveryMapView: 'delivery_map_view',
      deliverySellerMapPointSelection: 'delivery_seller_map_point_selection',
      deliverySellerMapPointCancel: 'delivery_seller_map_point_cancel',
      deliverySellerMapPointConfirm: 'delivery_seller_map_point_confirmation',
      deliveryPointSearchClick: 'delivery_point_search_click',
      deliverySellerPointSearchClick: 'delivery_seller_point_search_click',
      deliveryPointSearchPrefilled: 'delivery_point_search_prefilled',
      deliverySellerPointSearchPrefilled: 'delivery_seller_point_search_prefilled',
      deliverySellerPointSearchFilled: 'delivery_seller_point_search_filled',
      deliveryPointSearchFilled: 'delivery_point_search_filled',
      deliverySellerListView: 'delivery_seller_list_view',
      deliveryListView: 'delivery_list_view',
      deliverySellerListPointConfirmation: 'delivery_seller_list_point_confirmation',
      deliveryListPointConfirmation: 'delivery_list_point_confirmation',
      deliverySellerListClick: 'delivery_seller_list_click',
      deliveryListClick: 'delivery_list_click',
      deliverySellerMapClick: 'delivery_seller_map_click',
      deliveryMapClick: 'delivery_map_click',
      deliveryPurchaseBuyerInfo: 'delivery_purchase_buyer_info',
    },
    invoice: {
      chkbxOptIn: 'service_fee_chk_box_opted_in',
      chkbxOptOut: 'service_fee_chk_box_opted_out',
      privateOption: 'service_fee_private_click',
      businessOption: 'service_fee_business_click',
      prefillDataOptIn: 'service_fee_prefill_data_opt_in',
      prefillDataOptOut: 'service_fee_prefill_data_opt_out',
      firstName: 'service_fee_first_name',
      lastName: 'service_fee_last_name',
      company: 'service_fee_company',
      houseNumber: 'service_fee_house_number',
      apartmentNumber: 'service_fee_apartment_no',
      postalCode: 'service_fee_postal_code',
      city: 'service_fee_city',
      country: 'service_fee_country_select',
      countryDropDownClick: 'service_fee_country_click',
      vatNumber: 'service_fee_tax_number',
    },
  },
} as const;
